<template>
  <div>
    <!-- 버튼 area -->
    <div class="btn-stat">
      <button type="button" class="default btn mobile-hidden" @click="pivotReverse()">행열전환</button>
      <button type="button" class="default btn mobile-hidden" @click="filterBox()">조회설정</button>
      <button type="button" class="default btn mobile-hidden bg-sky" @click="copySheetData()">화면복사</button>
      <button type="button" class="default btn mobile-hidden bg-sky mobile-hidden" @click="$refs.downLoadPopup.open()">다운로드</button>
      <button type="button" class="default btn mobile-hidden bg-sky" @click="$refs.apiPopup.open()">Open API</button>
      <button type="button" style="width: auto;padding: 0 10px;" class="default btn mobile-hidden bg-sky" @click="onClickMyStatsPopup()">링크 주소(URL) 생성</button>
      <button type="button" class="default btn bg-sky" v-show="infoItem.cmmtDesc !== null" @click="$refs.comDescPopup.open()">주석</button>
      <button type="button" class="default btn mobile-hidden bg-sky">도움말</button>
    </div>
    <div class="ibsheet-box">
      <div class="sheet-top">
        <ul class="sheet-tab-menu">
          <li><a href="#n" class="tab1">통계표</a></li>
          <li><a href="#n" class="tab2" title="새창으로 열림" @click="chartFilterPopup()">차트(새창)</a></li>
        </ul>
        <ul style="display: flex; margin-top: 10px;">
          <li v-show="touristYn" style="margin-right: 20px;">
              <p><label><input type="checkbox" ref="checkTouristSumYn" @change="onChangeTouristSumYn" v-model="touristSumYn" > 시도, 군구 별 소계 데이터로 표시</label></p>
          </li>
          <p v-show="infoItem.msrUnitNm"> 단위 : {{ infoItem.msrUnitNm }}</p>
        </ul>
      </div>
      <div class="ibs-box">
        <!-- 조회설정(필터) 레이어 -->
        <div v-bind:ref="'filterSlide' + this.itemIdx" class="filter-slide-box">
          <h4>조회설정(필터)</h4>
          <button type="button" class="btn-filter-close" @click="filterBoxClose()"><span class="hidden">닫기</span>
          </button>
          <div class="pannel" style="height: calc(100% - 37px);">
            <div class="filter-list-inner">
              <div class="filter-list-box" style="height: 32px;">
                <!-- 검색 영역 -->
                <div class="filter-search">
                  <input type="search" v-model="filterSearchText" v-on:keyup.enter="filterSearch" placeholder="필터 검색">
                  <div v-show="filterSearchTotalCount > 0" style="display: flex;">
                    <span style="font-size: 12px; margin: 0 8px;"> {{filterSearchCurrent}}/{{filterSearchTotalCount}}</span>
                    <button type="button" @click="moveSearchIndex('up')" class="filter-search-up"></button>
                    <button type="button" @click="moveSearchIndex('down')" class="filter-search-down"></button>
                    <button type="button" @click="moveSearchIndex('delete')" class="filter-search-close"></button>
                  </div>
                </div>
              </div>
              <div class="filter-list-box">
                <div class="filter-tit">
                  <h5>시점 (연도)</h5>
                  <button type="button" @click="filterListToggle($event)"><span class="hidden">버튼</span></button>
                </div>
                <div class="check-list-box">
                  <ul>
                    <li>
                    <span class="inp-box">
                      <label class="filter-list-Label">
                        <input type="checkbox" ref="checkAllYear" checked data-all-check="all" @change="filterAllCheck($refs.yearTreeChecker, $event)">
                        <span class="filter-list-Label">전체 선택</span>
                      </label>
                    </span>
                    </li>
                    <!-- 시점 반복 START-->
                    <TreeChecker ref="yearTreeChecker" v-for="(data, i) in arrayYearItemFilterData"
                                 @checked-update="allCheckFromChild(arrayYearItemFilterData, $refs.checkAllYear)"
                                 :item="data" :index="i.toString()" :code="'col'" v-bind:key="i">
                    </TreeChecker>
                    <!-- 시점 반복 END-->
                  </ul>
                </div>
              </div>
              <!-- 지표통계 표두 필터 (null)  -->
              <!-- 지표통계 표측 필터  -->
              <div class="filter-list-box">
                <div class="filter-tit">
                  <h5>통계분류 ({{ rowFilterTitle }})</h5>
                  <button type="button" @click="filterListToggle($event)"><span class="hidden">버튼</span></button>
                </div>
                <div class="check-list-box">
                  <ul>
                    <li>
                      <span class="inp-box">
                        <label class="filter-list-Label">
                          <input type="checkbox" ref="checkAllRow" data-all-check="all" checked @change="filterAllCheck($refs.rowTreeChecker, $event)">
                          <span class="filter-list-Label">전체 선택</span>
                        </label>
                      </span>
                    </li>
                    <!-- 표측 반복 START-->
                    <TreeChecker ref="rowTreeChecker" v-for="(data, i) in arrayRowItemFilterData"
                                 @checked-update="allCheckFromChild(arrayRowItemFilterData, $refs.checkAllRow)"
                                 :item="data" :index="i.toString()" :code="'row'" v-bind:key="i">
                    </TreeChecker>
                    <!-- 표측 반복 END-->
                  </ul>
                </div>
              </div>
              <div class="pop-btn-box align-c">
                <button type="button" class="pop-btn w-fix bg-blue" @click="filterApply()">적용</button>
                <button type="button" class="pop-btn w-fix line-white">초기화</button>
              </div>
            </div>
          </div>
        </div>
        <!-- // 조회설정(필터) 레이어 -->
        <div class="sheet-box">
          <div v-bind:id="'sheetDiv' + this.itemIdx" class="sheet-div" style="height: 730px; /*display: none;*/">
          </div>
        </div>
      </div>
    </div>

    <div class="stat-section" v-show="this.showChart">
      <h4>선택된 영역의 차트</h4>
      <div v-bind:id="'chartDiv' + this.itemIdx" class="chart-div" style="height: 500px; /*display: none;*/"></div>
    </div>

    <!-- 다운로드 팝업 -->
    <DownLoadPopup ref="downLoadPopup" :stat-id="statId" @exportSheetData="exportSheetData" data-vue-ref="downLoadPopup"></DownLoadPopup>
    <!-- // 다운로드 팝업 -->

    <!-- 주석 팝업 -->
    <comDescPopup ref="comDescPopup" :cmmt-desc="infoItem.cmmtDesc"  data-vue-ref="comDescPopup"></comDescPopup>
    <!-- // 주석 팝업 -->

    <!-- 오픈API 팝업 -->
    <OpenApiPopup ref="apiPopup" :stat-id="statId" type="index" data-vue-ref="apiPopup"></OpenApiPopup>
    <!-- // 오픈API 팝업 -->

    <!-- 나의 통계표 팝업 -->
    <MyStatsPopup ref="statPopup" :stats-id="statId" :stats-name="stblTitle" data-vue-ref="statPopup"></MyStatsPopup>
    <!-- // 나의 통계표 팝업 -->
  </div>
</template>
<script>
import $ from 'jquery'
import * as api from "../api/StblData";
import TreeChecker from "../components/tree/TreeChecker";
import OpenApiPopup from "../components/popup/OpenApiPopup";
import DownLoadPopup from "../components/popup/DownLoadPopup";
import comDescPopup from "../components/popup/comDescPopup";
import pivotPopup from "../components/popup/pivotPopup";
import MyStatsPopup from "../components/popup/MyStatsPopup";
import {getStatsParameters} from "../api/my-stats";

export default {
  name: "StblIndexView",
  components: {OpenApiPopup, TreeChecker, DownLoadPopup, MyStatsPopup, pivotPopup, comDescPopup},
  props: {
    subItemId: {
      type: String,
      default: ''
    },
    statId: {
      type: String,
      default: ''
    },
    statNm: {
      type: String,
      default: ''
    },
    itemIdx: {
      type: String,
      default: ''
    },
    statsParametersId: {
      type: String,
      default: ''
    },
    infoItem: {}
  },

  data() {
    return {
      stblTitle: ''   // 통계표 명
      , valueKey: '지수'  // 통계 값 구분
      , staticBasicData: {} // 기본정보
      , arrayData: []   // 통계 기초 데이터
      , arrayDataFilter: [] // 통계 필터된 데이터
      , arrayChartData: [] // 차트전달용 초기 데이터
      , tblMgmNo: ''    // 통계 테이블 번호
      , colFilterTitle: ''  // 필터 타이틀
      , rowFilterTitle: ''  // 필터 타이틀
      , arrayYearItemFilterData: []
      , arrayColItemTitleData: []
      , arrayColItemFilterData: []  // 구조화된 표두 데이터
      , arrayRowItemTitleData: []
      , arrayRowItemFilterData: [] // 구조화된 표측 데이터
      , options: {}     // ibSheet 옵션
      , pivotOption: {}   // pivot 옵션
      , chartOptions: {}  // ibChart 옵션
      , stblSheet: {}   // sheet 객체
      , stblSheetId: "sheetDiv" + this.itemIdx  // sheet 객체 ID
      , selectRowData: ''   // 차트 생성 데이터 (시트 선택 Row 데이터)
      , stblChart: {}   // 차트 객체
      , stblChartId: "chartDiv" + this.itemIdx  // 차트 객체 ID
      , showChart: false  // 차트 표시여부
      , delimiterCha: '▷'   // 데이터처리 구분자
      , leftColWidth: '100'   // 좌측열 넓이
      , tradeYn: false  // 수출입통계
      , touristYn : false // 주요관광지 입장객
      , touristSumYn : true // 주요관광지 입장객 소계로 표시 여부
      , statsHstryList: [] // 공표후 통계표 수정/보완 내역 조회
      , yearKey : '시점'
      , beforeCrossColorInfo: {}
      , isIndexYn : true  // 지표통계여부
      , filterSearchText: ''
      , filterSearchList: []
      , filterSearchTotalCount: 0
      , filterSearchCurrent : 1
    }
  },
  mounted() {
    // 화면 로딩바 실행
    this.$emit('spinner-apply', true);
    if (this.subItemId === 'STBL-1025463') {
      this.tradeYn = true;
    }
    if (this.subItemId === 'STBL-1014278') {
      this.touristYn = true;
    }
    this.selectStblInfo()
  },
  beforeDestroy() {
    this.$emit('spinner-apply', false);
    this.disposeIbSheet();
    document.removeEventListener('click', this.outsideClickHandler);
  },
  created() {
    // 아웃사이드 클릭 팝업 종료
    const that = this;
    this.outsideClickHandler = (e) => {
      if (e.target.classList.contains('layer-popup-wrap')) {
        const vueReference = e.target.getAttribute('data-vue-ref');
        if (vueReference)
          that.$refs[vueReference].close();
        else
          this.popupClose(e.target)
      }
    };
    document.addEventListener('click', this.outsideClickHandler);
  },
  methods: {
    /**
     * 소계데이터 여부 변경 이벤트 처리
     * @param param
     */
    onChangeTouristSumYn (param) {
      if (this.touristSumYn !== true) {
        const text = "체크 해제하여 조회할 경우 많은양의 데이터로 인해 정상적으로 " +
          "\n데이터가 표시되지 않을수 있습니다. " +
          "\n조회설정 메뉴를 통해 검색조건을 지정하신 후 조회하시길 바랍니다. " +
          "\n재조회를 진행하시겠습니까?";

        if (confirm(text)) {
          // 재조회
          this.selectStblInfo();
        } else {
          this.touristSumYn = true;
          this.$set(this.$refs.checkTouristSumYn, 'checked', true);
        }
      } else {
        this.selectStblInfo();
      }
    },

    /**
     * 통계표 -> 데이터를 조회
     */
    selectStblInfo() {
      const paramData = {
        tblMgmNo: this.statId,
        upTblMgmNo: this.subItemId
      }
      // 조회 서비스 호출
      if (this.touristYn) {
        this.selectPivotStblTouristInfo(paramData)
      } else {
        this.selectPivotStblInfo(paramData)
      }
    },
    async selectPivotStblInfo(paramData) {
      const resultData = await api.selectPivotStblIndexInfo(paramData)
      this.setData(resultData);
    },
    async selectPivotStblTouristInfo(paramData) {
      if (this.touristSumYn) {
        this.setData(await api.selectPivotStblTouristSubSumInfo(paramData));
      } else {
        this.setData(await api.selectPivotStblTouristInfo(paramData));
      }
    },

    /**
     * 수출입통계 데이터 변환 처리
     * @param arrData
     * @returns {*}
     */
    setTransFormData (arrData) {
      return arrData.flatMap( item => [
        {
          '대분류' : item['대분류'].replace(/\n/g, "").trim(),
          '중분류' : item['중분류'].replace(/\n/g, "").trim(),
          '세분류' : item['세분류'].replace(/\n/g, "").trim(),
          '연도' : item['연도'],
          '시점' : item['시점'],
          '지수' : item['수입'],
          '수출입구분' : '수입'
        },{
          '대분류' : item['대분류'].replace(/\n/g, "").trim(),
          '중분류' : item['중분류'].replace(/\n/g, "").trim(),
          '세분류' : item['세분류'].replace(/\n/g, "").trim(),
          '연도' : item['연도'],
          '시점' : item['시점'],
          '지수' : item['수출'],
          '수출입구분' : '수출'
        }
      ])
    },
    /**
     * 캐리지리턴, trim 처리
     * @param arrData
     */
    replaceItemText (arrData) {
      arrData.forEach(item => {
        item['대분류'] = item['대분류'].replace(/\n/g, "").trim()
        item['중분류'] = item['중분류'].replace(/\n/g, "").trim()
        item['세분류'] = item['세분류'].replace(/\n/g, "").trim()
      })
    },

    /**
     * 통계표 정보 조회 및 데이터 설정
     * 통계표 타이틀
     * 통계표 데이터
     * @param paramData
     */
    setData(paramData) {
      this.stblTitle = this.infoItem.tblKorNm
      this.arrayData = paramData.dataList.data
      this.arrayDataFilter = this.arrayData

      // 피벗 기준 설정
      if (this.tradeYn === true) {  // 수출입 통계
        this.arrayRowItemTitleData = ['대분류', '중분류', '세분류']
        this.rowFilterTitle = this.arrayRowItemTitleData.join(",")
        this.pivotOption = {
          row: this.arrayRowItemTitleData,
          rowWidth: '160',
          col: ['시점', '수출입구분'],
          colWidth: '120',
          data: this.valueKey
        }
        this.chartSetOption = {
          categoriesKey: this.yearKey,
          stackKey: ['수출입구분'],
          seriesKey: this.arrayRowItemTitleData,
          valueKey:this.valueKey
        }

      } else if (this.touristYn === true) { // 주요관광지점 입장객 통계
        // 피벗 기준 설정
        if (this.touristSumYn) {
          this.arrayRowItemTitleData = ['시도','군구','구분','내외국인']
        } else {
          this.arrayRowItemTitleData = ['시도','군구','관광지','구분','내외국인']
        }
        this.rowFilterTitle = this.arrayRowItemTitleData.join(",")
        this.valueKey = '입장객수'
        this.pivotOption = {
          row: this.arrayRowItemTitleData,
          rowWidth: '160',
          col: ['시점','시점상세'],
          colWidth: '120',
          data: this.valueKey
        }
        this.chartSetOption = {
          categoriesKey: this.yearKey,
          stackKey: ['시점상세'],
          seriesKey: this.arrayRowItemTitleData,
          valueKey:this.valueKey
        }
      } else {  // 지표통계
        this.arrayRowItemTitleData = ['항목', '세부항목']
        this.rowFilterTitle = this.arrayRowItemTitleData.join(",")

        // 고용동향
        if (this.statId === 'STBL-1025925') {
          this.pivotOption.row = ['세부항목']
          this.pivotOption.col = ['시점','항목']
          this.chartSetOption = {
            categoriesKey: this.yearKey,
            stackKey: ['항목'],
            seriesKey: ['세부항목'],
            valueKey:this.valueKey
          }
        } else {
          this.pivotOption = {
            row: this.arrayRowItemTitleData,
            rowWidth: '160',
            col: '시점'.split(','),
            colWidth: '120',
            data: this.valueKey
          }
          this.chartSetOption = {
            categoriesKey: this.yearKey,
            stackKey: [],
            seriesKey: this.arrayRowItemTitleData,
            valueKey:this.valueKey
          }
        }
      }

      // 차트용 데이터 처리
      this.arrayChartData = this.arrayDataFilter;

      // 년도 필터 데이터 생성
      const setFilterYearData = (arrData, arrFilterData, checked) => {
        arrData.forEach(year => {
          let obj = {filterKey: '시점', itemName: year, checked: checked}
          arrFilterData.push(obj)
        })
      }

      let yearArray = [...new Set(this.arrayDataFilter.map(item => item['시점']))];
      setFilterYearData(yearArray, this.arrayYearItemFilterData, true)

      // 필터 데이터 세팅
      // 조회된 지표 데이터를 가지고 필터 데이터 생성함
      // [key1, key2 ...] 구조에서 사용 (명확한 상위키를 알수없음)
      const setFilterData2 = (arrData, arrTitle) => {
        // 필터 아이템 생성
        const makeFilterItem = (filterKey, key) => {
          return {
            child: []
            , filterKey: filterKey
            , itemName: key
            , itemKeyPath: this.delimiterCha
          }
        }
        const dataInfoMap = {}
        const resultArray = []

        arrData.forEach(rows => {
          let keyMap = rows.split(this.delimiterCha);
          keyMap.forEach((key, index) => {
            key = key.trim();
            let item = makeFilterItem(arrTitle[index], key);
            this.$set(item, 'checked', true);
            if (index === 0) {
              if (!dataInfoMap[key]) {
                item.upItemNo = 'ROOT'
                item.itemKeyPath = item.itemKeyPath + this.delimiterCha + key
                dataInfoMap[key] = item
                resultArray.push(item);
              }
            }
            else {
              // 1레벨, 2레벨 같은 명칭이 있을경우 에러 처리
              item.upItemNo = keyMap[index - 1]
              let parentKey = [];
              for (let i = 0; i < index; i++) {
                parentKey.push(keyMap[i]);
              }

              let parentKeyPath, itemKeyPath;
              parentKeyPath = parentKey.join(this.delimiterCha);
              itemKeyPath = parentKeyPath + this.delimiterCha + key

              if (!dataInfoMap[itemKeyPath]) {
                let parent = dataInfoMap[parentKeyPath]
                item.itemKeyPath = parent.itemKeyPath + this.delimiterCha + key
                dataInfoMap[parentKeyPath].child.push(item);
                dataInfoMap[itemKeyPath] = item
              }
            }
          })
        })
        return resultArray;
      }

      const getDataKeyMapList = (arrData) => {
        const rowMap = {};
        const rowKeyFunc = item => {
          return this.pivotOption.row.map(row => {
            return item[row].trim()
          }).join(this.delimiterCha);
        }
        arrData.forEach(item => {
          //const colKey = colKeyFunc(item)
          const rowKey = rowKeyFunc(item)
          if (!rowMap.hasOwnProperty(rowKey)) {
            rowMap[rowKey] = {};
          }
        });
        return Object.keys(rowMap)
      }

      if (this.statsParametersId) {
        //INFO: 나의 통계표
        this.setMyStatsParameters(this.statsParametersId);
      } else {
        this.arrayRowItemFilterData = setFilterData2(getDataKeyMapList(this.arrayData), this.arrayRowItemTitleData)
        this.initSheet(this.pivotOption, this.arrayDataFilter);
      }
    },

    /**
     * 통계표 -> 시트 초기화 및 데이터 생성
     * @param pivotOption
     * @param data
     */
    initSheet(pivotOption, data) {

      // 시트 초기화 시 로딩바 실행 (종료 -> 랜더링 완료 시)
      this.$emit('spinner-apply', true);

      // 수출입 통계
      if (this.tradeYn === true) {
        // 데이터 처리 (수입,수출)
        data = this.setTransFormData(data);
      }

      // 데이터 피벗 처리
      let returnData = this.pivotData(pivotOption, data, true);

      // 시트 COL 정보 설정
      this.options.Cols = returnData.headers;
      this.options.LeftCols = returnData.leftCols;

      // 시트 공통 설정
      this.options.Cfg = {
        //CanSort: 1,
        //SortIcons: 2,
        CanEdit: 4,  // 시트 편집 false
        //NoRenderHidden: 1,  // 보이지 않는 컬럼을 Dom 에 미리 생성하지 않도록 설정
        //FormulaRowNoFiltered: true,  // 필터된 데이터는 합계에서 제외 처리
        //NoFormatEscape: true,
        InfoRowConfig: {Layout: [{Value: "<div style='float: left'>" + this.stblTitle + "</div>"}, "Count"]},
        //SearchMode: 2,
        HeaderMerge: 4,  // 헤더행기준 자동 병합 처리
        DataMerge: 1,
        PrevColumnMerge: 1,
        IgnoreFocused: true,  // 조회후 포커스를 제외
        SelFocusColor: 1,
        FitWidth: true
      }
      // 이벤트 처리
      this.options.Events = {
        onRenderFinish: function (evtParam) {
        },
        onRenderFirstFinish: (evtParam) => {
          // 로딩바 제거
          this.$emit('spinner-apply', false);
          //this.stblSheet.selectRow( this.stblSheet.getFirstRow(), 1); // 첫번째 로우 선택
        },
        onSelectEnd: (evtParam) => {
          // 셀 영역 선택
          // 차트 생성
          this.selectToChart(evtParam);
        },
        onClick: (evtParam) => {
          // 헤더를 클릭 했을경우 처리
          if (evtParam.row.Kind === 'Header') {
            return;
          }
          // 색상변경 처리
          this.setCrossColor(evtParam);

          // 차트 생성
          this.clickToChart(evtParam);

        }
      }

      // IbSheet 객체 제거
      this.disposeIbSheet();

      // IBSheet 생성시 dom 존재 여부 체크
      let dom = document.querySelector('#' + this.stblSheetId);
      if (!dom) {
        this.$emit('spinner-apply', false);
        return;
      }

      // IBSheet 생성
      this.stblSheet = IBSheet.create({
        id: this.stblSheetId,     // 시트 객체 ID
        el: this.stblSheetId,     // 시트를 생성할 DIV객체 ID
        options: this.options,       // 초기화 구문 변수
        data: returnData.data   // 초기 로딩 데이터
      });
      this.stblSheet.vueComponent = this
      this.selectRowData = ''

      // 차트 초기화
      this.initChart()

    },
    /**
     * 차트 초기화
     */
    initChart() {
      this.chartOptions.initChartData = {
        chart: {type: 'column'},
        colors: ["#fd9c3c", "#e5404c", "#f6c8ba", "#b7b0b5", "#2ea4a8", "#47586f", "#adab6e", "#c9a9c3"],
        plotOptions: {
          series: {
            shadow: false,
            marker: {
              enabled: true, states: {hover: {enabled: true},select: {enabled: true}}
            }
          }
        },
        legend: {enabled: true},
        yAxis: {title: {text: this.stblTitle}},
        events : {
          searchEnd: (event) => {
            this.showChart = true;
          }
        }
      }

      // chart 초기화
      createIBChart(this.stblChartId, this.stblChartId, {
        width: "100%",
        height: "100%"
      });

      this.stblChart = window[this.stblChartId]
      this.stblChart.setOptions(this.chartOptions.initChartData);
    },
    /**
     * 시트 클릭 이벤트 처리 => 차트 생성
     * @param evtParam
     */
    clickToChart(evtParam) {
      let seriesNames = []
      let seriesName = ""
      this.options.LeftCols.map(item => item.Name).forEach(col => {
        seriesNames.push(evtParam.sheet.getValue(evtParam.row, col))
      })

      seriesName = seriesNames.join()
      let pparam = {
        datadirection: "horizontal",
        datarowcol: [evtParam.row],
        legendseriesname: [seriesName],
        legendtitle: "", // 범례
        startdatarowcol: this.options.Cols[0].Name,
        enddatarowcol: this.options.Cols[this.options.Cols.length - 1].Name,
        labelrowcol: evtParam.sheet.getHeaderRows()[evtParam.sheet.getHeaderRows().length - 1],
        startlabelrowcol: this.options.Cols[0].Name,
        endlabelrowcol: this.options.Cols[this.options.Cols.length - 1].Name,
        labeldirection: "horizontal",
        seriestype: ["column"]
      };
      SHEET2CHART(this.stblSheet, this.stblChart, pparam);
    },
    /**
     * 시트 셀 셀렉트 이벤트 처리 => 차트 생성
     * @param evtParam
     */
    selectToChart(evtParam) {
      let rowsArr = evtParam.rows,
        colsArr = evtParam.cols,
        seriestypeArr = [],
        legendseriesnameArr = [],
        i = 0,
        max = 0,
        selectCnt = 0,
        seriestypeStr = function () {
          let type = ["column", "spline", "areaspline"];
          let result = type[selectCnt];
          // 현재 데이터 수치들이 비슷비슷해서 여러가지 타입을 섞어서 보여주면 많이 이상하게 보여짐.
          // selectCnt = (selectCnt + 1) % type.length;
          return result;
        };
      let filteredColsArr = colsArr.filter(function (col) {
        return col !== 'sName' && col !== 'sDomain';
      });

      if (filteredColsArr.length === 0) {
        return;
      }

      for (i = 0, max = rowsArr.length; i < max; i++) {
        seriestypeArr.push(seriestypeStr());
        let seriesNames = []
        this.options.LeftCols.map(item => item.Name).forEach(col => {
          seriesNames.push(evtParam.sheet.getValue(rowsArr[i], col))
        })
        legendseriesnameArr.push(seriesNames.join())
      }

      let pparam = {
        datadirection: "horizontal",
        datarowcol: rowsArr,
        legendseriesname: legendseriesnameArr,
        legendtitle: "",  // 범례
        startdatarowcol: filteredColsArr[0],
        enddatarowcol: filteredColsArr[filteredColsArr.length - 1],
        labelrowcol: evtParam.sheet.getHeaderRows()[evtParam.sheet.getHeaderRows().length - 1],
        startlabelrowcol: filteredColsArr[0],
        endlabelrowcol: filteredColsArr[filteredColsArr.length - 1],
        labeldirection: "horizontal",
        seriestype: seriestypeArr
      };
      SHEET2CHART(this.stblSheet, this.stblChart, pparam);
    },
    /**
     * 시트 배경색 변경 처리
     * @param evtParam
     */
    setCrossColor(evtParam) {
      if (this.beforeCrossColorInfo.row) {
        evtParam.sheet.setAttribute(this.beforeCrossColorInfo.row, null, "Color", "#FFFFFF", 1);
      }

      evtParam.sheet.setAttribute(evtParam.row, null, "Color", "#e3eef0", 1);
      this.beforeCrossColorInfo.row = evtParam.row;

      if (this.beforeCrossColorInfo.column) {
        evtParam.sheet.setAttribute(null, this.beforeCrossColorInfo.column, "Color", "#FFFFFF", 1);
      }

      evtParam.sheet.setAttribute(null, evtParam.col, "Color", "#e3eef0", 1);
      this.beforeCrossColorInfo.column = evtParam.col;
    },

    /**
     * 조회한 원본데이터를 피벗데이터로 변환 처리
     * @param pivotOption
     * @param data
     * @param leftCol
     * @returns {{headers: *[], data: *[], rowMap: {}, leftCols: *[]}}
     */
    pivotData(pivotOption, data, leftCol) {
      const items = [];
      const itemMap = {};
      const rowMap = {};
      const headers = [];
      const headerMap = {};
      const leftCols = [];

      const colKeyFunc = item => {
        return colHeaderFunc(item).join(this.delimiterCha);
      }

      const rowKeyFunc = item => {
        return pivotOption.row.map(row => {
          return item[row]
        }).join(this.delimiterCha);
      }

      const colHeaderFunc = item => {
        return pivotOption.col.map(col => {
          return item[col];
        });
      }

      const createHeaderFunc = (rowArray, name, option) => {
        let colHeader = {Header: "", Type: "Text", Width: 100, Name: "", Align: "Right"}

        if (option !== undefined) {
          Object.assign(colHeader, option)
        }
        return Object.assign(colHeader, {
          Header: rowArray,
          Name: name.replace(/\s/g, "")
        })
      }

      //INFO 헤더 구분 설정
      pivotOption.row.forEach(rowItem => {
        const rowArray = new Array(pivotOption.col.length).fill('');
        rowArray[0] = rowItem;
        if (leftCol) {
          leftCols.push(createHeaderFunc(rowArray, rowItem, {Align: "Center", Width: this.pivotOption.rowWidth}))
        } else {
          headers.push(createHeaderFunc(rowArray, rowItem, {Align: "Center", Width: this.pivotOption.rowWidth}));
        }
      });

      data.forEach(item => {
        const colKey = colKeyFunc(item).replace(/\s/g, "");
        const rowKey = rowKeyFunc(item).replace(/\s/g, "");
        const key = colKey + this.delimiterCha + rowKey;

        if (!rowMap.hasOwnProperty(rowKey)) {
          const newItem = {}
          pivotOption.row.forEach(rowName => {
            newItem[rowName] = item[rowName];
          });

          rowMap[rowKey] = newItem;
          items.push(newItem);
        }

        //INFO 데이터 세팅
        const newItem = rowMap[rowKey];
        newItem[colKey] = item[this.valueKey] // || 0; // 값이 없을경우 0으로 처리
        itemMap[key] = item;

        //INFO 헤더 세팅
        if (!headerMap.hasOwnProperty(colKey)) {
          headerMap[colKey] = true;

          const colHeaders = colHeaderFunc(item);
          headers.push(createHeaderFunc(colHeaders, colKey, {Width: this.pivotOption.colWidth, Type: "Float", Format: "#,##0.#####", CanEmpty: 1}));
        }
      });

      return {
        headers: headers,
        data: items,
        rowMap: rowMap,
        leftCols: leftCols
      };
    },

    /**
     * 데이터 필터 처리
     * @param arrayList
     * @param strTarget
     * @param arrayFilterStr
     * @returns {*}
     */
    getDataFilter(arrayList, strTarget, arrayFilterStr) {
      return arrayList.filter(function (objects) {
        let result = false;
        arrayFilterStr.forEach((item) => {
          if (item === objects[strTarget]) {
            result = true;
          }
        });
        return result;
      });
    },

    /**
     * 데이터 필터 처리 (해당 조건을 제외한 데이터 처리)
     * @param arrayList
     * @param strTarget
     * @param arrayFilterStr
     * @returns {*}
     */
    getDataRemoveFilter(arrayList, strTarget, arrayFilterStr) {
      return arrayList.filter(function (objects) {
        let result = false;
        arrayFilterStr.forEach((item) => {
          if (item !== objects[strTarget]) {
            result = true;
          }
        });
        return result;
      });
    },

    /**
     * IBSheet 객체 제거
     */
    disposeIbSheet() {
      // TODO : ibloader 사용시 삭제
      // 시트 객체가 존재할 경우 삭제
      if (IBSheet.hasSheet(this.stblSheetId)) {
        window[this.stblSheetId].dispose();
      }
      // 시트 객체가 존재할 경우 삭제
      if (IBSheet.hasSheet(this.stblSheetId)) {
        window["pivotSheet_" + this.stblSheetId].dispose();
      }

    },

    /**
     * 조회설정 박스 열기
     */
    filterBox() {
      if (this.$refs['filterSlide' + this.itemIdx].classList.contains('open')) {
        this.$refs['filterSlide' + this.itemIdx].classList.remove('open')
      } else {
        this.$refs['filterSlide' + this.itemIdx].classList.add('open')
      }
    },

    /**
     * 조회설정 박스 닫기
     */
    filterBoxClose() {
      this.$refs['filterSlide' + this.itemIdx].classList.remove('open')
    },

    /**
     * 옵션 리스트 드롭다운
     * @param evt
     */
    filterListToggle(evt) {
      const target = evt.target
      // $(target).parents('.filter-tit').next('.check-list-box').slideToggle()
      $(target).parents('.filter-list-box').toggleClass('off')
      $(target).toggleClass('close')
    },

    /**
     * 필터 검색
     */
    filterSearch(){
      this.initFilterSearchResult();
      if (this.filterSearchText.trim().length > 0) {
        this.filterSearchList = Array.from(document.querySelectorAll('.filter-list-Label')).filter(label => label.innerText.indexOf(this.filterSearchText) > -1)
      }
      this.filterSearchTotalCount = this.filterSearchList.length;
      this.filterSearchMove();
    },
    /**
     * 필터 검색결과 초기화
     */
    initFilterSearchResult() {
      //this.filterSearchList = Array.from(document.querySelectorAll('.filter-list-Label'))
      this.filterSearchList.forEach(item => {
        item.classList.remove('on-search'); // li
        item.classList.remove('on-search-selected');
      });
      this.filterSearchList = [];
      this.filterSearchTotalCount = 0;
      this.filterSearchCurrent = 1;
    },
    /**
     * 필터 검색 결과 이동
     */
    filterSearchMove() {
      this.filterSearchList.forEach((item, idx) => {
        if (this.filterSearchCurrent === idx + 1){
          item.classList.add('on-search-selected');
          // 스크롤 이동
          const parentEl = item.closest('.check-list-box');
          parentEl.scrollTo(0, item.offsetTop - parentEl.offsetTop - 10);

        } else {
          item.classList.add('on-search');
          item.classList.remove('on-search-selected');
        }
      })
    },
    moveSearchIndex(type) {
      if (type === 'delete') {
        this.filterSearchText = '';
        this.initFilterSearchResult();
      } else if (type === 'up') {
        if (this.filterSearchCurrent > 1) {
          this.filterSearchCurrent --;
        } else {
          this.filterSearchCurrent = this.filterSearchTotalCount;
        }
        this.filterSearchMove();
      } else if (type === 'down') {
        if (this.filterSearchCurrent !== this.filterSearchTotalCount) {
          this.filterSearchCurrent ++;
        } else {
          this.filterSearchCurrent = 1;
        }
        this.filterSearchMove();
      }
    },

    /**
     * 필터 적용
     */
    filterApply() {
      // 년도 필터 처리
      // 원본 데이터에서 필터 데이터로 변환
      this.arrayDataFilter = this.arrayData // 초기데이터
      // 수출입 통계
      if (this.tradeYn === true) {
        // 데이터 처리 (수입,수출)
        this.replaceItemText(this.arrayDataFilter);
      }

      if (this.arrayYearItemFilterData && !this.$refs.checkAllYear.checked) { // 전체 선택 일경우 제외
        let result = [];
        this.arrayYearItemFilterData.forEach((item) => {
          if (item.checked) {
            result.push({
              key: item.filterKey,
              value: item.itemName,
            });
          }
        });
        if (result.length === 0) {
          this.$set(this.$refs.checkAllYear, 'checked', true);
          this.$refs.yearTreeChecker.forEach(checker => {
            checker.updateCheckAll(true);
          })
        } else {
          const arrayKeys = [...new Set(result.map(item => item.key))]
          arrayKeys.forEach(key => {
            let arrayFilterStr = result.filter(item => item.key === key).map(item => item['value'])
            this.arrayDataFilter = this.getDataFilter(this.arrayDataFilter, key, arrayFilterStr)
          })
        }
      }
      // 통계분류 데이터 필터처리
      if (this.arrayRowItemFilterData && !this.$refs.checkAllRow.checked) { // 전체 선택 일경우 제외
        //result.push(...this.extraFilter(this.arrayRowItemFilterData, this.arrayRowItemTitleData));
        let result = []
        result.push(...this.extraFilter(this.arrayRowItemFilterData, this.arrayRowItemTitleData));
        // 전체 선택이 false 인데 체크된 데이터가 없을 경우 전체 선택을 체크해주고 필터는 수행하지 않음
        if (result.length === 0) {
          //this.$refs.checkAllRow.checked = true
          this.$set(this.$refs.checkAllRow, 'checked', true);
          this.$refs.rowTreeChecker.forEach(checker => {
            checker.updateCheckAll(true);
          })
        } else {
          let tempArrayFilteredData = [];
          result.forEach(filterItem => {
            let tempArrayData = this.arrayDataFilter // 필터된 데이터
            const arrKey = Object.keys(filterItem)
            arrKey.forEach(key => {
              tempArrayData = tempArrayData.filter(item => item[key] === filterItem[key])
            })
            tempArrayFilteredData.push(...tempArrayData)
          })
          this.arrayDataFilter = tempArrayFilteredData;
        }
      }
      // 피벗 기준 데이터 정렬 처리
      let sortArray =[];
      this.pivotOption.row.forEach(item => {
        if (this.yearKey !== item) {
          sortArray.push({field: item + '_SORT', direction: 'asc'})
        } else {
          sortArray.push({field: item, direction: 'desc'})
        }
      })
      const sortDataArray = this.sortByFields(this.arrayDataFilter, sortArray);

      // 시트 초기화
      this.initSheet(this.pivotOption, sortDataArray);
      // 필터창 닫기
      this.filterBoxClose()
    },
    /**
     * 배열 정렬 처리
     * @param array 정렬처리할 배열
     * @param sortArray 정렬 조건 배열
     * @returns {*}
     */
    sortByFields (array, sortArray) {
      return array.slice().sort((a, b) => {
        for (let {field, direction}of sortArray) {
          const valueA = a[field];
          const valueB = b[field];
          const dir = direction === 'desc' ? -1 : 1;
          if (valueA === valueB) continue;

          if (typeof  valueA === 'string') {
            return valueA.localeCompare(valueB) * dir;
          }
          return (valueA - valueB) * dir;
        }
        return 0;
      })
    },
    /**
     * 필터 데이터 항목 검사
     * @param data
     * @param titleData
     * @returns {*[]}
     */
    extraFilter(data, titleData) {
      const result = [];
      data.forEach((item) => {
        if (item.checked) { // 체크 되어있을경우
          if (item.child && Array.isArray(item.child) && item.child.length > 0) { // 자식객체가 있을경우
            if (this.isAllCheck(item.child)) {
              // 자식이 모두 체크되어있을경우
              result.push(this.pathFilterStr(item.itemKeyPath, titleData))
            } else {
              // 자식검사
              result.push(...this.extraFilter(item.child, titleData));
            }
          } else {
            // 자식객체가 없을경우
            result.push(this.pathFilterStr(item.itemKeyPath, titleData))
          }
        }
      });
      return result;
    },
    /**
     * 필터 조건 문자열로 변환
     * @param keyStr
     * @param titleData
     * @returns {{}}
     */
    pathFilterStr(keyStr, titleData) {
      const arrTitle = titleData.map(keys => keys.levelTitle === undefined ? keys : keys.levelTitle)
      const filter = keyStr.split(this.delimiterCha).splice(2)
      const result = {}
      filter.forEach((item, index) => {
        if (item !== '') {
          result[arrTitle[index]] = item
        }
      })
      return result;
    },
    // 전체 옵션 체크박스 선택/해제
    filterAllCheck(treeChecker, event) {
      treeChecker.forEach(checker => {
        checker.updateCheckAll(event.target.checked);
      })
    },
    // 1레벨 체크박스가 모두 선택/해제 일 경우 전체선택 상태를 업데이트 처리
    allCheckFromChild(arrData, target) {
      target.checked = this.isAllCheck(arrData)
    },
    // 전체 체크 상태여부 확인
    isAllCheck(arrData) {
      let result = true;
      arrData.forEach((item) => {
        if (item.checked === false) {
          result = false;
        }
        if (item.child && Array.isArray(item.child) && result) {
          if (!this.isAllCheck(item.child)) {
            result = false;
          }
        }
      });
      return result;
    },

    /**
     * 팝업 열기
     * @param popId
     */
    popupOpen(popId) {
      popId.classList.add('open')
    },

    /**
     * 팝업 닫기
     * @param popId
     */
    popupClose(popId) {
      popId.classList.remove('open')
    },

    /**
     * 차트 새창으로 열기
     */
    chartPopup() {
      window.openerVue = this;
      window.open('/portal/chart/ChartPopup', '_blank')
    },

    /**
     * 차트 새창으로 열기
     */
    chartFilterPopup() {
      window.openerVue = this;
      window.open('/portal/chart/chartFilterIndexPopup', '_blank')
    },
    /**
     * 링크 주소(URL) 생성 팝업 열기
     * @param evt
     */
    onClickMyStatsPopup() {
      this.$refs.statPopup.open({
        pivotOption: {
          col: this.pivotOption.col,
          row: this.pivotOption.row
        },
        filters: this.arrayDataFilter,
        filterData: {
          year: this.arrayYearItemFilterData,
          col: this.arrayColItemFilterData,
          row: this.arrayRowItemFilterData
        }
      });
    },
    /**
     * 링크 주소(URL) 접근 시 처리
     * @param parametersId
     */
    setMyStatsParameters(parametersId) {
      getStatsParameters(parametersId).then(parameters => {
        if (parameters.hasOwnProperty('pivotOption')) {
          this.pivotOption.col = parameters.pivotOption.col;
          this.pivotOption.row = parameters.pivotOption.row;
        }

        if (parameters.hasOwnProperty('filters'))
          this.arrayDataFilter = parameters.filters;

        if (parameters.hasOwnProperty('filterData')) {
          this.arrayYearItemFilterData = parameters.filterData.year;
          this.arrayColItemFilterData = parameters.filterData.col;
          this.arrayRowItemFilterData = parameters.filterData.row;
        }

        this.initSheet(this.pivotOption, this.arrayDataFilter);
      });
    },

    /**
     * 행열전환
     */
    pivotReverse() {
      let row = this.pivotOption.row
      let rowWidth = this.pivotOption.rowWidth
      this.pivotOption.row = this.pivotOption.col
      this.pivotOption.rowWidth = this.pivotOption.colWidth
      this.pivotOption.col = row
      this.pivotOption.colWidth = rowWidth
      this.initSheet(this.pivotOption, this.arrayDataFilter);
    },

    /**
     * 화면 복사
     */
    copySheetData () {
      let sheetData = this.stblSheet.extractDataText({excludeHideData:1 })
      // 클립보드에 복사
      navigator.clipboard.writeText(sheetData).then(() => {
        alert("클립보드에 저장되었습니다.");
      }).catch( err => {
      })
    },
    /**
     * 다운로드
     * @param type
     */
    exportSheetData (type) {
      let data = []
      data.push(new Date().getFullYear())
      data.push(new Date().getMonth() + 1 < 10? "0" + (new Date().getMonth() + 1) : new Date().getMonth() + 1);
      data.push(new Date().getDate())
      data.push(this.statId)
      this.stblSheet.exportData({fileName: data.join('_')+type});

      // 다운로드 이력저장
      const paramData = {
        statsType: '02',  // 지표통계
        tblMgmNo: this.statId, // 통계표 id
        downType : ''
      }
      if (type === '.xlsx') {
        paramData.downType = '01'
      } else if (type === '.csv') {
        paramData.downType = '02'
      } else if (type === '.txt') {
        paramData.downType = '03'
      }
      api.saveDownloadHistory(paramData)
    },

  }
}
</script>

<style scoped>
</style>
